import React from 'react';
import { Box, Typography, Card, CardContent, Button, Alert } from '@mui/joy';
import { useNavigate } from 'react-router-dom';
import { PageHeader } from '../../components/common/PageHeader';

export const AffiliateSettingsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <PageHeader title="Affiliate program" description="Manage referrals, commissions, and your affiliate account." />

      <Card variant="outlined" sx={{ mb: 3 }}>
        <CardContent>
          <Typography level="h4" sx={{ mb: 2 }}>
            Quick Actions
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Button
              variant="solid"
              color="success"
              onClick={() => navigate('/affiliate-dashboard')}
            >
              Go to Affiliate Dashboard
            </Button>
          </Box>
        </CardContent>
      </Card>

      <Alert color="primary">
        <Typography level="body-md">
          Your affiliate settings and detailed dashboard are available in the dedicated affiliate section.
          Use the "Go to Affiliate Dashboard" button above to access your referral tracking, commission history, and payout information.
        </Typography>
      </Alert>
    </Box>
  );
};
